import { Button, Modal, Form, message } from "antd";
import { useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { handleUpdateExternal } from "../../../../api/customers";

export default function UpdateExternal({
  isVisible,
  setVisible,
  selected,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleUpdateExternal,
    onSuccess: () => {
      message.success("Created Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["metrics"] });
      queryClient.invalidateQueries({ queryKey: ["customers"] });
      setVisible(false);
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const onSubmit = async () => {
    let v = selected?.external === "N" ? "Y" : "N";
    await mutate({ _id: selected?._id, data: { external: v } });
  };

  const clearForm = async () => {
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title=""
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={() => setVisible(false)}>
          No
        </Button>,
        <Button
          key="submit"
          form="updateExternal"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
        >
          Yes
        </Button>,
      ]}
    >
      <Form
        id="updateExternal"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="text-center mt-6">
          <div className="text-lg">{selected?.name}</div>
          <div className="">
            <span>Are you sure you want to</span>

            <span className="font-bold mx-1">
              set external to: {selected?.external === "N" ? "Y" : "N"}?
            </span>
          </div>
        </div>
      </Form>
    </Modal>
  );
}
